import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, useIntl } from 'react-intl';

const Owl = (props) => {
  const intl = useIntl();

  return (
    <svg
      role="img"
      focusable="false"
      aria-labelledby="svgOwlTitle"
      aria-describedby="svgOwlDescription"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 900 900"
    >
      <title id="svgOwlTitle">
        <FormattedMessage id="image.coloring-book.owl" />
      </title>
      <desc id="svgOwlDescription">{intl.formatMessage({ id: 'image.coloring-book.owl-description' })}</desc>
      <g id="OwlLayer_2" data-name="Layer 2">
        <path
          onClick={() => props.onFill(0)}
          fill={props.colors[0]}
          fillRule="evenodd"
          stroke="#000"
          strokeWidth="2px"
          strokeMiterlimit="10"
          className="cls-1"
          d="M628.32,134c1.63.62,3.26,1.27,4.87,2A215.55,215.55,0,0,1,662,150.9,215.55,215.55,0,0,0,633.19,136C631.58,135.28,630,134.63,628.32,134Z"
        />
        <path
          onClick={() => props.onFill(1)}
          fill={props.colors[1]}
          fillRule="evenodd"
          stroke="#000"
          strokeWidth="2px"
          strokeMiterlimit="10"
          className="cls-1"
          d="M597,124.1l1.24.38.82.25-2.37-.73Z"
        />
        <path
          onClick={() => props.onFill(2)}
          fill={props.colors[2]}
          fillRule="evenodd"
          stroke="#000"
          strokeWidth="2px"
          strokeMiterlimit="10"
          className="cls-1"
          d="M416.91,761.77c-.54.4-1.08.79-1.59,1.21q5.56.38,11.12.69c1.81.1,3.61.17,5.42.26-3.26-.37-6.51-.82-9.76-1.31C420.37,762.35,418.64,762.08,416.91,761.77Z"
        />
        <path
          onClick={() => props.onFill(3)}
          fill={props.colors[3]}
          fillRule="evenodd"
          stroke="#000"
          strokeWidth="2px"
          strokeMiterlimit="10"
          className="cls-1"
          d="M602.88,125.88c2.92.87,5.85,1.73,8.77,2.61l-9.51-2.83Z"
        />
        <path
          onClick={() => props.onFill(4)}
          fill={props.colors[4]}
          fillRule="evenodd"
          stroke="#000"
          strokeWidth="2px"
          strokeMiterlimit="10"
          className="cls-1"
          d="M494.34,763.72c-1.29.14-2.59.27-3.88.39q-3.88.38-7.77.64c-2,.14-4.08.25-6.13.35-.41,0-.83.06-1.24.07,14.13.09,28.27-.17,42.39-.7a36.36,36.36,0,0,0-4.3-3.37l-2.22.36C505.59,762.37,500,763.11,494.34,763.72Z"
        />
        <path
          onClick={() => props.onFill(5)}
          fill={props.colors[5]}
          fillRule="evenodd"
          stroke="#000"
          strokeWidth="2px"
          strokeMiterlimit="10"
          className="cls-1"
          d="M518.65,826.78a69.51,69.51,0,0,0,9.83-24c2.76-14.32-.3-28.7-10.77-38.32-14.12.53-28.26.79-42.39.7l-2.26.12c-3.95.16-7.91.27-11.86.28h0c-7.84,0-15.82-.36-23.85-1.09q-2.75-.26-5.49-.55c-1.81-.09-3.61-.16-5.42-.26q-5.55-.31-11.12-.69c-11.86,9.59-15.43,24.73-12.53,39.81a69.51,69.51,0,0,0,9.83,24,68.31,68.31,0,0,0,10.3,12.65l36,1.34c15.87.58,31.75.61,47.62.33A69.28,69.28,0,0,0,518.65,826.78Z"
        />
        <path
          onClick={() => props.onFill(6)}
          fill={props.colors[6]}
          fillRule="evenodd"
          stroke="#000"
          strokeWidth="2px"
          strokeMiterlimit="10"
          className="cls-1"
          d="M722.55,757a18.39,18.39,0,0,0-6.68-2.83c-21.5-5.9-46.17-2.12-68.36-.42-19.7,1.51-39.36,3.63-59,5.59,9.65,11.86,9.53,26.84,2.59,40.72-2.1-6.08-3.11-11.81-6.26-17.51a76.05,76.05,0,0,0-5.73-8.89c-.86-1.15-4.93-4.8-6.07-6.68,9.3,21.64,6.11,46-5.35,66.14-.78,1.37-3.52,4.32-4.3,6.17,27.7-.91,55.23-.92,82.71-4.68,11.94-1.63,23.85-6.08,32.42-14.56,5.9-5.83,10.39-13.63,18-16.82a68.62,68.62,0,0,1,8.75-2.48c4.05-1.06,7.77-2.46,9.62-6,3.41-6.64-3-15.52.94-21.89C718.79,768.05,731.19,763.82,722.55,757Z"
        />
        <path
          onClick={() => props.onFill(7)}
          fill={props.colors[7]}
          fillRule="evenodd"
          stroke="#000"
          strokeWidth="2px"
          strokeMiterlimit="10"
          className="cls-1"
          d="M553.08,787.07c3.53,21.35-4.21,43.51-24.94,52.45-.84.36-1.68.74-2.53,1.12q15.2-.46,30.38-1.09c2.39-.1,4.78-.17,7.18-.25A116.85,116.85,0,0,0,553.08,787.07Z"
        />
        <path
          onClick={() => props.onFill(8)}
          fill={props.colors[8]}
          fillRule="evenodd"
          stroke="#000"
          strokeWidth="2px"
          strokeMiterlimit="10"
          className="cls-1"
          d="M358.25,767c-1.14,1.88-5.21,5.53-6.07,6.68a76.05,76.05,0,0,0-5.73,8.89c-3.15,5.7-4.16,11.43-6.26,17.51-7.33-14.67-7-30.55,4.34-42.7-27.4-2.06-54.84-3.45-82.06-2.33-2.94-3.17-5.87-6.32-8.62-9.56-9.69-11.39-17.26-26.34-28.77-35.93-4.71-3.92-7.2,3-6.71,6.51.87,6.15,4.42,11.59,6.69,17.27,3.19,7.93,6.27,15.9,9.5,23.81A296.82,296.82,0,0,0,181.28,768c-5.55,1.7-11.28,3.67-15.37,7.8s-5.92,11.06-2.64,15.84c5.88,8.55,21.09,3.48,28.18,11,8,8.53-1.43,20.35,11.05,26.44,4.74,2.31,10.19,2.54,15.47,2.74l148.77,5.5c-1.12-1.57-2.6-3.28-3.14-4.23C352.14,813,349,788.62,358.25,767Z"
        />
        <path
          onClick={() => props.onFill(9)}
          fill={props.colors[9]}
          fillRule="evenodd"
          stroke="#000"
          strokeWidth="2px"
          strokeMiterlimit="10"
          className="cls-1"
          d="M378.19,787.07a116.88,116.88,0,0,0-10.12,50.33l33.25,1.23C382,829.2,374.77,807.77,378.19,787.07Z"
        />
        <path
          onClick={() => props.onFill(10)}
          fill={props.colors[10]}
          fillRule="evenodd"
          stroke="#000"
          strokeWidth="2px"
          strokeMiterlimit="10"
          className="cls-1"
          d="M361.19,126.61q4.28-1.45,8.55-2.81Q365.47,125.15,361.19,126.61Z"
        />
        <path
          onClick={() => props.onFill(11)}
          fill={props.colors[11]}
          fillRule="evenodd"
          stroke="#000"
          strokeWidth="2px"
          strokeMiterlimit="10"
          className="cls-1"
          d="M355.54,128.59c-1.07.39-2.12.8-3.18,1.2,2.75-1,5.52-2,8.3-3-1.71.59-3.42,1.18-5.12,1.79Z"
        />
        <path
          onClick={() => props.onFill(12)}
          fill={props.colors[12]}
          fillRule="evenodd"
          stroke="#000"
          strokeWidth="2px"
          strokeMiterlimit="10"
          className="cls-1"
          d="M235,512.83c.05.4.09.8.13,1.2,0,.23.05.47.08.7,0-.23-.05-.47-.08-.7C235.09,513.63,235.05,513.23,235,512.83Z"
        />
        <path
          onClick={() => props.onFill(13)}
          fill={props.colors[13]}
          fillRule="evenodd"
          stroke="#000"
          strokeWidth="2px"
          strokeMiterlimit="10"
          className="cls-1"
          d="M416.91,761.77h0c1.73.31,3.46.58,5.19.85C420.37,762.35,418.64,762.08,416.91,761.77Z"
        />
        <path
          onClick={() => props.onFill(14)}
          fill={props.colors[14]}
          fillRule="evenodd"
          stroke="#000"
          strokeWidth="2px"
          strokeMiterlimit="10"
          className="cls-1"
          d="M314.44,437.28c1.85,3.93,3.62,7.88,5.34,11.83,1.71.79,3.43,1.56,5.17,2.25,32.25,12.72,64.45,6.54,91.44-14.85a111.74,111.74,0,0,0,40.77-72.87q-2.24-5.72-4.46-11.44c-.23-.57-.45-1.14-.67-1.71-3.66-9.38-19.42-31.71-5.49-39.38,3.58-2,7.85-2.1,11.94-2.19L501,308c4-.09,8.22-.16,12,1.33a13.59,13.59,0,0,1,3.39,1.89c4.7,3.69,4.18,9.64,1.39,15.27L505.9,350.61q-2.82,5.73-5.65,11.45c.75,7.13,1.87,15.92,3.11,19.35a118.38,118.38,0,0,0,43.75,57.06c25.41,17.41,55.84,22.08,85.63,17.75,3.12-7,6.39-14,9.89-21,24.43-48.5,59-91.89,91.06-135.64-4.3-43.21-14.18-88.73-41.27-121.89a126,126,0,0,0-12.85-13.53c-.48-.44-1-.88-1.45-1.31-.78-.69-1.58-1.36-2.39-2s-1.43-1.18-2.15-1.75-1.41-1.12-2.13-1.66c-.93-.71-1.89-1.41-2.85-2.09-.58-.42-1.16-.84-1.75-1.25-1.59-1.1-3.21-2.17-4.88-3.2A215.55,215.55,0,0,0,633.19,136c-1.61-.69-3.24-1.34-4.87-2-.53-.21-1.06-.39-1.6-.59-1.11-.41-2.23-.82-3.36-1.21l-1.82-.61-3.25-1.07-1.77-.55c-1.18-.38-2.37-.74-3.57-1.1l-1.3-.39c-2.92-.88-5.85-1.74-8.77-2.61-.76.09-1.49.18-2.14.3q-10.54,1.91-20.85,4.79a225.27,225.27,0,0,0-39.63,15.21,213.88,213.88,0,0,0-35.62,22.24c-3.21,2.48-29.92,25.21-28.11,27.24-20.14-22.53-40.16-41.39-70.27-52.22-16.43-5.9-33.3-9.64-50.63-12.59-.72-.12-2.53-.29-4.73-.51-3,1.14-6,2.32-9,3.57l-.35.15q-6.7,2.82-13.2,6l-.11.06c-2,1-4.06,2-6.06,3.1l-.69.37q-6.13,3.27-12,6.92l-.91.57c-1.74,1.1-3.47,2.23-5.17,3.39l-.58.39q-2.83,1.94-5.58,4l-.62.47c-1.58,1.19-3.13,2.4-4.67,3.64l-1.07.86Q285.8,168,281,172.66c-.36.34-.71.69-1.06,1-1.31,1.31-2.59,2.63-3.85,4-.28.29-.56.58-.83.88q-2.24,2.44-4.36,5l-.68.85c-1.18,1.44-2.34,2.92-3.46,4.42-.33.44-.66.87-1,1.32-1.3,1.77-2.57,3.57-3.79,5.42a130.56,130.56,0,0,0-8.13,14.16C236,245.91,229.69,287.64,227.18,327c.52-8.05,1.19-16.2,2.09-24.38C259.48,346.07,291.87,389.37,314.44,437.28ZM591.5,219.13c33.69,2.87,68.61,55.75,61.92,104.58-.2,1.42-1.6,1.5-2.08.38-6.53-15.29-10.45-31.79-18.72-45.64-8.71-14.58-21.08-23.82-34-28.31-30.12-10.46-48,20.8-57.53,55.74-2.11,7.73-9.36,8.11-11.39,0C516.71,253.67,560.17,216.45,591.5,219.13Zm-229.78,0c31.34-2.68,74.79,34.54,61.79,86.75-2,8.11-9.27,7.73-11.39,0-9.55-34.94-27.4-66.2-57.52-55.74-12.91,4.49-25.28,13.73-34,28.31-8.27,13.85-12.19,30.35-18.72,45.64-.48,1.12-1.89,1-2.08-.38C293.12,274.88,328,222,361.72,219.13Z"
        />
        <path
          onClick={() => props.onFill(15)}
          fill={props.colors[15]}
          fillRule="evenodd"
          stroke="#000"
          strokeWidth="2px"
          strokeMiterlimit="10"
          className="cls-1"
          d="M226.7,335.31q.21-4,.46-8.07Q226.91,331.29,226.7,335.31Z"
        />
        <path
          onClick={() => props.onFill(16)}
          fill={props.colors[16]}
          fillRule="evenodd"
          stroke="#000"
          strokeWidth="2px"
          strokeMiterlimit="10"
          className="cls-1"
          d="M252.26,611.36a185.2,185.2,0,0,1-8.6-30.33A185.2,185.2,0,0,0,252.26,611.36Z"
        />
        <path
          onClick={() => props.onFill(17)}
          fill={props.colors[17]}
          fillRule="evenodd"
          stroke="#000"
          strokeWidth="2px"
          strokeMiterlimit="10"
          className="cls-1"
          d="M482.69,764.75q3.88-.27,7.77-.64C487.87,764.36,485.28,764.56,482.69,764.75Z"
        />
        <path
          onClick={() => props.onFill(18)}
          fill={props.colors[18]}
          fillRule="evenodd"
          stroke="#000"
          strokeWidth="2px"
          strokeMiterlimit="10"
          className="cls-1"
          d="M473.06,765.29l2.26-.12c.41,0,.83,0,1.24-.07C475.4,765.16,474.23,765.24,473.06,765.29Z"
        />
        <path
          onClick={() => props.onFill(19)}
          fill={props.colors[19]}
          fillRule="evenodd"
          stroke="#000"
          strokeWidth="2px"
          strokeMiterlimit="10"
          className="cls-1"
          d="M461.2,765.57h0c-7.84,0-15.82-.36-23.85-1.09C445.38,765.21,453.36,765.6,461.2,765.57Z"
        />
        <path
          onClick={() => props.onFill(20)}
          fill={props.colors[20]}
          fillRule="evenodd"
          stroke="#000"
          strokeWidth="2px"
          strokeMiterlimit="10"
          className="cls-1"
          d="M599.08,124.73l3.06.93,9.51,2.83,1.3.39c1.2.36,2.39.72,3.57,1.1l1.77.55,3.25,1.07,1.82.61c1.13.39,2.25.8,3.36,1.21.54.2,1.07.38,1.6.59,1.63.62,3.26,1.27,4.87,2A215.55,215.55,0,0,1,662,150.9c1.67,1,3.29,2.1,4.88,3.2.59.41,1.17.83,1.75,1.25,1,.68,1.92,1.38,2.85,2.09.72.54,1.43,1.1,2.13,1.66s1.44,1.16,2.15,1.75,1.61,1.34,2.39,2c.49.43,1,.87,1.45,1.31a126,126,0,0,1,12.85,13.53h0c-2.55-40.38-14.08-84.27-27.78-121.91-5.64-15.49-49.7,40.64-68.29,68.06l.36.12Z"
        />
        <path
          onClick={() => props.onFill(21)}
          fill={props.colors[21]}
          fillRule="evenodd"
          stroke="#000"
          strokeWidth="2px"
          strokeMiterlimit="10"
          className="cls-1"
          d="M266.8,188.83c1.12-1.5,2.28-3,3.46-4.42l.68-.85q2.13-2.55,4.36-5c.27-.3.55-.59.83-.88,1.26-1.36,2.54-2.68,3.85-4,.35-.35.7-.7,1.06-1q4.75-4.64,9.89-8.85L292,163c1.54-1.24,3.09-2.45,4.67-3.64l.62-.47q2.74-2,5.58-4l.58-.39c1.7-1.16,3.43-2.29,5.17-3.39l.91-.57q5.85-3.66,12-6.92l.69-.37c2-1.06,4-2.1,6.06-3.1l.11-.06q6.5-3.19,13.2-6l.35-.15c3-1.25,6-2.43,9-3.57h0c.5-.19,1-.35,1.5-.54,1.06-.4,2.11-.81,3.18-1.2h0c-16.16-25-65.44-89.21-71.42-72.77-13.93,38.28-25.65,83.05-27.93,124-.42,7.55,1.81,12.59,5.81,15.78l0,0c1.22-1.85,2.49-3.65,3.79-5.42C266.14,189.7,266.47,189.27,266.8,188.83Z"
        />
        <path
          onClick={() => props.onFill(22)}
          fill={props.colors[22]}
          fillRule="evenodd"
          stroke="#000"
          strokeWidth="2px"
          strokeMiterlimit="10"
          className="cls-1"
          d="M350.86,130.33h0c2.2.22,4,.39,4.73.51,17.33,3,34.2,6.69,50.63,12.59,30.11,10.83,50.13,29.69,70.27,52.22-1.81-2,24.9-24.76,28.11-27.24a213.88,213.88,0,0,1,35.62-22.24A225.27,225.27,0,0,1,579.89,131q10.29-2.88,20.85-4.79c.65-.12,1.38-.21,2.14-.3l-.74-.22-3.06-.93-.82-.25L597,124.1l-.31-.1-.36-.12c-1.64-.52-3.27-1-4.89-1.59-3.77-1.28-7.61-2.48-11.48-3.61-4.63-1.35-9.33-2.59-14-3.77-7.08-1.79-14.19-3.45-21.19-5-15.8-3.57-32.78-4.32-48.91-4.81-8.88-.27-17.74-.14-26.58.33-.49,0-1,.07-1.47.09q-12.23.7-24.39,2.27c-5,.63-9.94,1.33-14.89,2.15q-13.33,2.2-26.53,5.25-6.58,1.52-13.13,3.2h0q-4.67,1.22-9.33,2.53l-.28.08q-4.71,1.34-9.4,2.8l-.1,0q-4.28,1.35-8.55,2.81l-.53.19c-2.78,1-5.55,2-8.3,3C351.86,130,351.36,130.14,350.86,130.33Z"
        />
        <path
          onClick={() => props.onFill(23)}
          fill={props.colors[23]}
          fillRule="evenodd"
          stroke="#000"
          strokeWidth="2px"
          strokeMiterlimit="10"
          className="cls-1"
          d="M226,391.48v0Z"
        />
        <path
          onClick={() => props.onFill(24)}
          fill={props.colors[24]}
          fillRule="evenodd"
          stroke="#000"
          strokeWidth="2px"
          strokeMiterlimit="10"
          className="cls-1"
          d="M342.19,733.92q-4.44-2.82-8.67-5.91Q337.75,731.1,342.19,733.92Z"
        />
        <path
          onClick={() => props.onFill(25)}
          fill={props.colors[25]}
          fillRule="evenodd"
          stroke="#000"
          strokeWidth="2px"
          strokeMiterlimit="10"
          className="cls-1"
          d="M402.3,739.33c6.25.57,15,.81,19.18,6,3.67,4.58,1.85,12.19-3,15.3-.56.36-1.09.76-1.62,1.14,1.73.31,3.46.58,5.19.85,3.25.49,6.5.94,9.76,1.31q2.75.3,5.49.55c8,.73,16,1.12,23.85,1.09h0c3.95,0,7.91-.12,11.86-.28,1.17,0,39.06.08,44.65-.82.74-.12-5-3.24-4.3-3.37-.23-.15-.44-.32-.67-.47-4.8-3.11-6.62-10.72-2.95-15.3,4.18-5.19,12.93-5.43,19.18-6a84.13,84.13,0,0,1,20.67.62A80.87,80.87,0,0,1,570,745.82a281.74,281.74,0,0,0,37.29-17.26c1.19-12.07,2.89-24.08,5.18-36,2.55-13.33,5.08-21.2,9.46-40.91-1.84.08-18.64,2.54-18.87,4q1.89-11.48,3.77-23l10.44-63.43c-9.23,4.31-18,9.52-27.35,13.62,12.31-43.32,24.57-85.62,42.79-126.66-29.79,4.33-60.22-.34-85.63-17.75a118.38,118.38,0,0,1-43.75-57.06c-1.24-3.43-2.36-12.22-3.11-19.35l-7.7,15.6c-5.67,11.47-15.82,36.08-25.29,11.84l-10.1-25.86a111.74,111.74,0,0,1-40.77,72.87c-27,21.39-59.19,27.57-91.44,14.85-1.74-.69-3.46-1.46-5.17-2.25,19.45,44.47,31.43,90.21,43.44,137.14-9.21-4.35-17.88-9.79-27-14.35L345,635.59l3.18,23c-.2-1.45-16.93-4.36-18.76-4.49,3.85,19.82,6.18,27.76,8.38,41.15q3.15,19.19,4.4,38.62l2.43,1.51q6.31,3.86,13,7.18c1.47.74,3,1.47,4.46,2.17l.77.35a82.75,82.75,0,0,1,18.8-5.18A84.13,84.13,0,0,1,402.3,739.33Z"
        />
        <path
          onClick={() => props.onFill(26)}
          fill={props.colors[26]}
          fillRule="evenodd"
          stroke="#000"
          strokeWidth="2px"
          strokeMiterlimit="10"
          className="cls-1"
          d="M322.18,719c.36.32.76.6,1.12.92-.82-.71-1.63-1.45-2.44-2.18C321.31,718.15,321.73,718.59,322.18,719Z"
        />
        <path
          onClick={() => props.onFill(27)}
          fill={props.colors[27]}
          fillRule="evenodd"
          stroke="#000"
          strokeWidth="2px"
          strokeMiterlimit="10"
          className="cls-1"
          d="M632.74,456.22c-18.22,41-30.48,83.34-42.79,126.66,9.31-4.1,18.12-9.31,27.35-13.62l-10.44,63.43q-1.89,11.47-3.77,23c.23-1.45,17-3.91,18.87-4-4.38,19.71-6.91,27.58-9.46,40.91-2.29,11.91-4,23.92-5.18,36l-.09.8c4.08-2.25,8.13-4.58,12.1-7.05,48.39-30.12,73-77.42,89.14-129.52a675.44,675.44,0,0,0,29.69-217.61c-.48-17.11-1-34.23-2-51.32-.51-8.12-1.16-16.43-2-24.82l-.42.57c-32,43.75-66.63,87.14-91.06,135.64C639.13,442.2,635.86,449.19,632.74,456.22Z"
        />
        <path
          onClick={() => props.onFill(28)}
          fill={props.colors[28]}
          fillRule="evenodd"
          stroke="#000"
          strokeWidth="2px"
          strokeMiterlimit="10"
          className="cls-1"
          d="M329.41,654.15c1.83.13,18.56,3,18.76,4.49l-3.18-23-8.76-63.69c9.11,4.56,17.78,10,27,14.35-12-46.93-24-92.67-43.44-137.14-1.72-3.95-3.49-7.9-5.34-11.83-22.57-47.91-55-91.21-85.17-134.67-.9,8.18-1.57,16.33-2.09,24.38a2.29,2.29,0,0,1,0,.25q-.25,4-.46,8.07h0c-1,18.59-1.13,37.36-.7,56.17v.09q.15,6.92.43,13.84c0,1.18.09,2.36.14,3.54.06,1.55.11,3.09.18,4.64q.17,3.36.35,6.74c.05.95.09,1.89.14,2.83,0,.55,0,1.11.08,1.66q.36,6.17.77,12.35c0,.73.1,1.46.15,2.19q.24,3.58.5,7.16l.12,1.62.24,3.1c.1,1.22.19,2.44.29,3.65q.48,6,1,12.08c.06.61.11,1.22.16,1.83s.11,1.25.17,1.87c.36,4,.74,8,1.13,12,.1,1.11.22,2.23.33,3.35.16,1.6.31,3.19.47,4.79.08.75.16,1.5.23,2.26l.39,3.69.39,3.77q.66,6.17,1.33,12.3c.05.4.09.8.13,1.2,0,.23.05.47.08.7q.66,6.1,1.29,12.31c1.11,10.94,2.2,22.08,3.69,33.13.85,6.28,1.85,12.53,3,18.71.14.72.28,1.43.43,2.15a185.2,185.2,0,0,0,8.6,30.33q1.17,3,2.47,6,2.57,5.8,5.31,11.53A377.49,377.49,0,0,0,292,683.54q7.32,10.35,15.42,20.15c2.06,2.49,4.22,4.87,6.44,7.19.36.38.71.76,1.07,1.13,1.93,2,3.94,3.87,6,5.73.81.73,1.62,1.47,2.44,2.18,1.72,1.49,3.47,2.93,5.25,4.34,1.31,1,2.64,2,4,3l1,.7q4.23,3.09,8.67,5.91h0q-1.28-19.41-4.4-38.62C335.59,681.91,333.26,674,329.41,654.15Z"
        />
        <path
          onClick={() => props.onFill(29)}
          fill={props.colors[29]}
          fillRule="evenodd"
          stroke="#000"
          strokeWidth="2px"
          strokeMiterlimit="10"
          className="cls-1"
          d="M517.81,326.48c2.79-5.63,3.31-11.58-1.39-15.27a13.59,13.59,0,0,0-3.39-1.89c-3.77-1.49-7.94-1.42-12-1.33l-42.56.93c-4.09.09-8.36.22-11.94,2.19-13.93,7.67,1.83,30,5.49,39.38.22.57.44,1.14.67,1.71q2.22,5.71,4.46,11.44l10.1,25.86c9.47,24.24,19.62-.37,25.29-11.84l7.7-15.6q2.82-5.71,5.65-11.45Z"
        />
        <path
          onClick={() => props.onFill(30)}
          fill={props.colors[30]}
          fillRule="evenodd"
          stroke="#000"
          strokeWidth="2px"
          strokeMiterlimit="10"
          className="cls-1"
          d="M301.89,324.09c6.53-15.29,10.45-31.79,18.72-45.64,8.71-14.58,21.08-23.82,34-28.31,30.12-10.46,48,20.8,57.52,55.74,2.12,7.73,9.37,8.11,11.39,0,13-52.21-30.45-89.43-61.79-86.75C328,222,293.12,274.88,299.81,323.71,300,325.13,301.41,325.21,301.89,324.09Z"
        />
        <path
          onClick={() => props.onFill(31)}
          fill={props.colors[31]}
          fillRule="evenodd"
          stroke="#000"
          strokeWidth="2px"
          strokeMiterlimit="10"
          className="cls-1"
          d="M541.1,305.88c9.56-34.94,27.41-66.2,57.53-55.74,12.91,4.49,25.28,13.73,34,28.31,8.27,13.85,12.19,30.35,18.72,45.64.48,1.12,1.88,1,2.08-.38,6.69-48.83-28.23-101.71-61.92-104.58-31.33-2.68-74.79,34.54-61.79,86.75C531.74,314,539,313.61,541.1,305.88Z"
        />
        <path
          onClick={() => props.onFill(32)}
          fill={props.colors[32]}
          fillRule="evenodd"
          stroke="#000"
          strokeWidth="2px"
          strokeMiterlimit="10"
          className="cls-1"
          d="M402.79,802.79c-2.9-15.08.67-30.22,12.53-39.81.51-.42,1.05-.81,1.59-1.21h0c.53-.38,1.06-.78,1.62-1.14,4.8-3.11,6.62-10.72,3-15.3-4.18-5.19-12.93-5.43-19.18-6a84.13,84.13,0,0,0-20.67.62,82.75,82.75,0,0,0-18.8,5.18,53,53,0,0,0-17.73,11.6c-.2.21-.37.42-.57.63-11.38,12.15-11.67,28-4.34,42.7,2.1-6.08,3.11-11.81,6.26-17.51a76.05,76.05,0,0,1,5.73-8.89c.86-1.15,4.93-4.8,6.07-6.68-9.3,21.64-6.11,46,5.35,66.14.54,1,2,2.66,3.14,4.23a6.63,6.63,0,0,1,1.38,2.72c0-.89,0-1.78-.05-2.67a116.88,116.88,0,0,1,10.12-50.33c-3.42,20.7,3.79,42.13,23.13,51.56.6.3,1.18.62,1.81.89,4.48,1.93,9,4.19,13.74,5.53a48.06,48.06,0,0,0,7.61,1.49c1.33.16,6.08-.41,7,.3-1.69-1.34-3.29-2.65-4.82-4q-1.93-1.68-3.72-3.43a68.31,68.31,0,0,1-10.3-12.65A69.51,69.51,0,0,1,402.79,802.79Z"
        />
        <path
          onClick={() => props.onFill(33)}
          fill={props.colors[33]}
          fillRule="evenodd"
          stroke="#000"
          strokeWidth="2px"
          strokeMiterlimit="10"
          className="cls-1"
          d="M573,767c1.14,1.88,5.21,5.53,6.07,6.68a76.05,76.05,0,0,1,5.73,8.89c3.15,5.7,4.16,11.43,6.26,17.51,6.94-13.88,7.06-28.86-2.59-40.72-.72-.89-1.49-1.76-2.32-2.61A52.4,52.4,0,0,0,570,745.82,80.87,80.87,0,0,0,549.64,740a84.13,84.13,0,0,0-20.67-.62c-6.25.57-15,.81-19.18,6-3.67,4.58-1.85,12.19,2.95,15.3.23.15.44.32.67.47a36.36,36.36,0,0,1,4.3,3.37c10.47,9.62,13.53,24,10.77,38.32a71.67,71.67,0,0,1-21.94,38.31c-.64.59-1.25,1.19-1.91,1.76-1.53,1.33-3.13,2.64-4.82,4,.9-.71,5.65-.14,7-.3a48.06,48.06,0,0,0,7.61-1.49,83.59,83.59,0,0,0,11.21-4.41c.85-.38,1.69-.76,2.53-1.12,20.73-8.94,28.47-31.1,24.94-52.45a116.85,116.85,0,0,1,10.09,52.23c0,.26,0,.52,0,.77a2.52,2.52,0,0,1,.22-.78c.78-1.85,3.52-4.8,4.3-6.17C579.13,813,582.32,788.62,573,767Z"
        />
      </g>
    </svg>
  );
};

Owl.propTypes = {
  onFill: PropTypes.func,
  colors: PropTypes.array,
};

export default Owl;
